// extracted by mini-css-extract-plugin
export default {"wrapper":"StatusField_wrapper__I+mgK","labelTextGreen":"StatusField_labelTextGreen__vC1YC","labelTextRed":"StatusField_labelTextRed__eDg+1"};